export class ModelData {
    constructor(modelUID, room) {
        this.modelUID = modelUID;
        this.room = room;
        this.scripts = new Map();
    }
}
